import styled from 'styled-components';
import React from 'react';

import colors from '@front/common/src/utils/colors';
import { formatPercentage, formatPricePerMonth } from '@front/common/src/utils/formatting';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import TextButton from '@front/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card.new_opt_in.wellness');

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

type MembershipCardContentOptinProps = {
  getMoreInfoPress: () => void;
};

const MembershipCardContentOptin = ({ getMoreInfoPress }: MembershipCardContentOptinProps) => {
  const membershipConfig = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()];
  const membershipPrice = membershipConfig.monthlyPrice;
  const membershipReductionsPercentage = membershipConfig.wellnessReductionsPercentage;

  return (
    <Container>
      <span>
        <Text.SMBold>{`${t('.text_1')} `}</Text.SMBold>
        <Text.SMBold color={colors.pink120}>{`${formatPercentage(membershipReductionsPercentage)} `}</Text.SMBold>
        <Text.SMBold>{t('.text_2')}</Text.SMBold>
      </span>
      <span>
        <Text.SM>{`${t('.text_3', { pricePerMonth: formatPricePerMonth(membershipPrice) })} `}</Text.SM>
        <TextButton size='sm' onClick={getMoreInfoPress}>
          {t('base.learn_more')}
        </TextButton>
      </span>
    </Container>
  );
};

export default MembershipCardContentOptin;
